import {
  Instant3cn81rq2kpflk as Instant,
  Companion_getInstance3vjikuur3h0k4 as Companion_getInstance,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  Index19x9ylte4qic1 as Index,
  AdminTableColumns2kd3zhffh08h8 as AdminTableColumns,
} from '../../lightningdb/Annotations.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { System_instance3dr57gee6r420 as System_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../lightningdb/HasId.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function ExternalAsyncTaskRequest$Companion$$childSerializers$_anonymous__mxk0lt() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ExternalAsyncTaskRequest$Companion$$childSerializers$_anonymous__mxk0lt_0() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ExternalAsyncTaskRequest$Companion$$childSerializers$_anonymous__mxk0lt_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ExternalAsyncTaskRequest$Companion$$childSerializers$_anonymous__mxk0lt);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ExternalAsyncTaskRequest$Companion$$childSerializers$_anonymous__mxk0lt_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.u33_1 = [null, null, tmp_1, tmp_3, null, null, null, lazy(tmp_4, ExternalAsyncTaskRequest$Companion$$childSerializers$_anonymous__mxk0lt_1), null];
      }
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.externalintegration.ExternalAsyncTaskRequest', this, 9);
        tmp0_serialDesc.a1b('_id', false);
        tmp0_serialDesc.a1b('ourData', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.a1b('expiresAt', false);
        tmp0_serialDesc.a1b('createdAt', true);
        tmp0_serialDesc.a1b('response', true);
        tmp0_serialDesc.a1b('result', true);
        tmp0_serialDesc.a1b('action', true);
        tmp0_serialDesc.a1b('lastAttempt', true);
        tmp0_serialDesc.a1b('processingError', true);
        tmp0_serialDesc.c1b(new (AdminTableColumns())(['_id', 'action', 'createdAt', 'result', 'processingError']));
        this.c4m_1 = tmp0_serialDesc;
      }
      d4m(encoder, value) {
        var tmp0_desc = this.c4m_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().u33_1;
        tmp1_output.a15(tmp0_desc, 0, value.z33_1);
        tmp1_output.a15(tmp0_desc, 1, value.a34_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.b34_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !value.c34_1.equals(System_instance.b1m())) {
          tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.c34_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.d34_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, StringSerializer_getInstance(), value.d34_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.e34_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, StringSerializer_getInstance(), value.e34_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.f34_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, StringSerializer_getInstance(), value.f34_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !value.g34_1.equals(Companion_getInstance().c1m_1)) {
          tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.g34_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.h34_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, StringSerializer_getInstance(), value.h34_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.d4m(encoder, value instanceof ExternalAsyncTaskRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.c4m_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_input = decoder.l13(tmp0_desc);
        var tmp14_cached = Companion_getInstance_0().u33_1;
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.x13(tmp0_desc, 2, tmp14_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.x13(tmp0_desc, 3, tmp14_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.x13(tmp0_desc, 7, tmp14_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.z13(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.x13(tmp0_desc, 2, tmp14_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.x13(tmp0_desc, 3, tmp14_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.x13(tmp0_desc, 7, tmp14_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.z13(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return ExternalAsyncTaskRequest().e4m(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.c4m_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_0().u33_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[7].f2(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var ExternalAsyncTaskRequestClass;
function ExternalAsyncTaskRequest() {
  if (ExternalAsyncTaskRequestClass === VOID) {
    class $ {
      constructor(_id, ourData, expiresAt, createdAt, response, result, action, lastAttempt, processingError) {
        Companion_getInstance_0();
        createdAt = createdAt === VOID ? System_instance.b1m() : createdAt;
        response = response === VOID ? null : response;
        result = result === VOID ? null : result;
        action = action === VOID ? null : action;
        lastAttempt = lastAttempt === VOID ? Companion_getInstance().c1m_1 : lastAttempt;
        processingError = processingError === VOID ? null : processingError;
        this.z33_1 = _id;
        this.a34_1 = ourData;
        this.b34_1 = expiresAt;
        this.c34_1 = createdAt;
        this.d34_1 = response;
        this.e34_1 = result;
        this.f34_1 = action;
        this.g34_1 = lastAttempt;
        this.h34_1 = processingError;
      }
      f40() {
        return this.z33_1;
      }
      f4m(_id, ourData, expiresAt, createdAt, response, result, action, lastAttempt, processingError) {
        return new (ExternalAsyncTaskRequest())(_id, ourData, expiresAt, createdAt, response, result, action, lastAttempt, processingError);
      }
      j34(_id, ourData, expiresAt, createdAt, response, result, action, lastAttempt, processingError, $super) {
        _id = _id === VOID ? this.z33_1 : _id;
        ourData = ourData === VOID ? this.a34_1 : ourData;
        expiresAt = expiresAt === VOID ? this.b34_1 : expiresAt;
        createdAt = createdAt === VOID ? this.c34_1 : createdAt;
        response = response === VOID ? this.d34_1 : response;
        result = result === VOID ? this.e34_1 : result;
        action = action === VOID ? this.f34_1 : action;
        lastAttempt = lastAttempt === VOID ? this.g34_1 : lastAttempt;
        processingError = processingError === VOID ? this.h34_1 : processingError;
        return $super === VOID ? this.f4m(_id, ourData, expiresAt, createdAt, response, result, action, lastAttempt, processingError) : $super.f4m.call(this, _id, ourData, expiresAt, createdAt, response, result, action, lastAttempt, processingError);
      }
      toString() {
        return 'ExternalAsyncTaskRequest(_id=' + this.z33_1 + ', ourData=' + this.a34_1 + ', expiresAt=' + this.b34_1.toString() + ', createdAt=' + this.c34_1.toString() + ', response=' + this.d34_1 + ', result=' + this.e34_1 + ', action=' + this.f34_1 + ', lastAttempt=' + this.g34_1.toString() + ', processingError=' + this.h34_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.z33_1);
        result = imul(result, 31) + getStringHashCode(this.a34_1) | 0;
        result = imul(result, 31) + this.b34_1.hashCode() | 0;
        result = imul(result, 31) + this.c34_1.hashCode() | 0;
        result = imul(result, 31) + (this.d34_1 == null ? 0 : getStringHashCode(this.d34_1)) | 0;
        result = imul(result, 31) + (this.e34_1 == null ? 0 : getStringHashCode(this.e34_1)) | 0;
        result = imul(result, 31) + (this.f34_1 == null ? 0 : getStringHashCode(this.f34_1)) | 0;
        result = imul(result, 31) + this.g34_1.hashCode() | 0;
        result = imul(result, 31) + (this.h34_1 == null ? 0 : getStringHashCode(this.h34_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ExternalAsyncTaskRequest()))
          return false;
        if (!(this.z33_1 === other.z33_1))
          return false;
        if (!(this.a34_1 === other.a34_1))
          return false;
        if (!this.b34_1.equals(other.b34_1))
          return false;
        if (!this.c34_1.equals(other.c34_1))
          return false;
        if (!(this.d34_1 == other.d34_1))
          return false;
        if (!(this.e34_1 == other.e34_1))
          return false;
        if (!(this.f34_1 == other.f34_1))
          return false;
        if (!this.g34_1.equals(other.g34_1))
          return false;
        if (!(this.h34_1 == other.h34_1))
          return false;
        return true;
      }
      static e4m(seen0, _id, ourData, expiresAt, createdAt, response, result, action, lastAttempt, processingError, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance().c4m_1);
        }
        var $this = createThis(this);
        $this.z33_1 = _id;
        $this.a34_1 = ourData;
        $this.b34_1 = expiresAt;
        if (0 === (seen0 & 8))
          $this.c34_1 = System_instance.b1m();
        else
          $this.c34_1 = createdAt;
        if (0 === (seen0 & 16))
          $this.d34_1 = null;
        else
          $this.d34_1 = response;
        if (0 === (seen0 & 32))
          $this.e34_1 = null;
        else
          $this.e34_1 = result;
        if (0 === (seen0 & 64))
          $this.f34_1 = null;
        else
          $this.f34_1 = action;
        if (0 === (seen0 & 128))
          $this.g34_1 = Companion_getInstance().c1m_1;
        else
          $this.g34_1 = lastAttempt;
        if (0 === (seen0 & 256))
          $this.h34_1 = null;
        else
          $this.h34_1 = processingError;
        return $this;
      }
    }
    initMetadataForClass($, 'ExternalAsyncTaskRequest', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance});
    ExternalAsyncTaskRequestClass = $;
  }
  return ExternalAsyncTaskRequestClass;
}
//region block: exports
export {
  ExternalAsyncTaskRequest as ExternalAsyncTaskRequestlkl21m26cexi,
  Companion_getInstance_0 as Companion_getInstance2j3pmvyptu679,
};
//endregion

//# sourceMappingURL=ExternalAsyncTaskRequest.mjs.map
